import { atomFamily } from "jotai/utils";
import { atomWithQuery } from "jotai-tanstack-query";
import {
  arrayRemove,
  arrayUnion,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import { customFirestore } from "../firebase";

const pinnedBuildIdsAtom = atomFamily(
  ({ organizationId }: { organizationId: string }) => {
    return atomWithQuery(() => ({
      queryKey: ["pinnedBuildIds", organizationId],
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      queryFn: async (): Promise<string[]> => {
        const settingsRef = doc(customFirestore, "settings", organizationId);
        const snap = await getDoc(settingsRef);
        if (!snap.exists()) {
          return [];
        }
        const data = snap.data();
        const pinned = data.pinnedBuildIds;
        return Array.isArray(pinned) ? pinned.filter((v) => typeof v === "string") : [];
      },
    }));
  },
  (a, b) => a.organizationId === b.organizationId
);

const pinBuildId = async (organizationId: string, buildId: string) => {
  const settingsRef = doc(customFirestore, "settings", organizationId);
  await updateDoc(settingsRef, { pinnedBuildIds: arrayUnion(buildId) });
};

const unpinBuildId = async (organizationId: string, buildId: string) => {
  const settingsRef = doc(customFirestore, "settings", organizationId);
  await updateDoc(settingsRef, { pinnedBuildIds: arrayRemove(buildId) });
};

export { pinnedBuildIdsAtom, pinBuildId, unpinBuildId };
